// extracted by mini-css-extract-plugin
export default {"loading_wrapper":"EnergyTrend_loading_wrapper__RdAKv","trend_chart":"EnergyTrend_trend_chart__BncaD"};